var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-actions"},_vm._l((_vm.items),function(item,key){return _c('span',{key:item.code || key,staticClass:"menu-actions__link",class:{disabled: item.disabled},attrs:{"href":"item.link"},on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v("\n        "+_vm._s(item.name)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }